import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { SettingsTumbler } from '.';
import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { isMessengerIntegration as selectIsMessengerIntegration } from '../../../../config/selectors';
import { selectJoinWithMicrophoneOff, toggleJoinWithMicrophoneOffAction } from '../../../../settings';

export const JoinWithMicrophoneOffTumbler: FunctionComponent = () => {
    const { toggleJoinWithMicrophoneOff } = useActions({
        toggleJoinWithMicrophoneOff: toggleJoinWithMicrophoneOffAction,
    });

    const isMessengerIntegration = useSelector(selectIsMessengerIntegration);
    const joinWithMicrophoneOff = useSelector(selectJoinWithMicrophoneOff);

    const onChange = () => toggleJoinWithMicrophoneOff(!joinWithMicrophoneOff);

    if (isMessengerIntegration) {
        return null;
    }

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'sound-join-with-microphone-off')}
            checked={joinWithMicrophoneOff}
            onChange={onChange}
            testId="join-with-microphone-off-tumbler"
        />
    );
};
